// extracted by mini-css-extract-plugin
module.exports = {"container":"App_container__3Xny5","image":"App_image__37R-W"};